import { PaginationConfig } from 'components/datagrid/types';

const paginateConfig: PaginationConfig = {
	text: '{posIni} - {posEnd} de {total}',
	rowsOptions: [25, 50, 100],
};

export default paginateConfig;
